import { Section } from "./Section";

const STEPS = [
  ["Describe your idea", "Type the setup in plain English — instrument, time frame and the condition you trade. No coding required."],
  ["AI writes the strategy", "You get entry, exit, stop-loss and position-sizing rules, translated into an editable, version-controlled strategy."],
  ["Backtest & tune", "Run it across a decade of NSE & BSE data with costs and slippage. Compare drawdown and consistency before you trust it."],
  ["Paper trade live signals", "Deploy on live market data with virtual capital. Watch real fills and your own rule-following for as long as you need."],
  ["Go live or subscribe", "Trade it yourself, share it with subscribers as a SEBI-registered analyst, or subscribe to someone else's verified strategy."],
];

export const HowItWorks = () => (
  <Section id="how-it-works" alt testId="how-section" eyebrow="How it works" title="From plain-English idea to live strategy in five steps"
    intro="The same pipeline a quant desk uses — minus the Python stack and the six-month build.">
    <ol className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
      {STEPS.map(([t, d], i) => (
        <li key={t} className="tn-card tn-reveal p-5 bg-[var(--tn-bg)]" style={{ transitionDelay: `${i * 70}ms` }} data-testid={`how-step-${i + 1}`}>
          <div className="flex items-center gap-2 font-mono text-[11px] text-[var(--tn-cyan)]">
            <span className="w-6 h-6 rounded-full border border-[rgba(34,211,238,0.4)] flex items-center justify-center">{i + 1}</span>
            Step 0{i + 1}
          </div>
          <h3 className="font-display font-medium mt-5">{t}</h3>
          <p className="text-sm text-[var(--tn-muted)] mt-3 leading-relaxed">{d}</p>
        </li>
      ))}
    </ol>
    <p className="font-mono text-xs text-[var(--tn-muted)] mt-8 max-w-2xl leading-relaxed">
      Every step is logged: strategy version, data range, cost assumptions and paper-trading results stay attached to the strategy, so you always know how a decision was reached.
    </p>
  </Section>
);
